import { createAction } from "redux-actions";
import { PRIVATE_ROUTE } from "./constants";

export const saveLoginUrlAction = createAction(PRIVATE_ROUTE.SAVE_LOGIN_URL);
export const discardLoginUrlAction = createAction(
  PRIVATE_ROUTE.DISCARD_LOGIN_URL
);
